import store from '../store';
import { actionTypes } from '../types';
const processedNodes = new Set();

function processTextNode($el, ignoreTermKey) {
	const newText = store.state.glossaryByKeyword.reduce((processedText, item) => {
		if (item[1].id === ignoreTermKey || !item[0].test(processedText)) return processedText;
		processedText = processedText.replace(
			item[0],
			`<span data-articleid="${item[1].id}" class="glossaryTerm">$1</span>$2` // data-definition="${item[1]}"
		);
		return processedText;
	}, $el.textContent);
	if (newText !== $el.textContent) {
		const replacementNode = document.createElement('span');
		replacementNode.innerHTML = newText;
		$el.parentElement.insertBefore(replacementNode, $el);
		[...replacementNode.querySelectorAll('.glossaryTerm')].forEach(($term) => {
			$term.addEventListener('click', (event) => {
				store.dispatch(actionTypes.setExhibition, {
					exhibitionID: 'glossary',
					articleID: event.target.dataset.articleid,
				});
			});
		});
		$el.parentElement.removeChild($el);
	}
	processedNodes.add($el);
}

/**
 * ## highlightGlossary
 * Recursive function that scans the current node for text nodes,
 * all other nodes will be inserted in this function again.
 * Text nodes will be scanned for glossary terms and highlighted
 * with `processTextNode`.
 * @param {[type]} $el DOM element
 * @param { options } ignoreTermKey the glossary term with this key will not be highlighted
 */
export function highlightGlossary($el, { ignoreTermKey }) {
	if (processedNodes.has($el)) return;
	$el.childNodes.forEach(($child) => {
		if (processedNodes.has($child)) return;
		if ($child.nodeType === 3) {
			// if it's a text node
			processTextNode($child, ignoreTermKey);
		} else if (!$el.classList.contains('glossaryTerm')) {
			highlightGlossary($child, { ignoreTermKey });
		}
	});
}
